import type { Map as MapLibreMap } from 'maplibre-gl';
import { flightDuration } from '@/features/map';
import type { SearchItem } from './types';

/** Frames an areal place, or flies to a point. */
export function flyToItem(map: MapLibreMap, item: SearchItem) {
  if (item.extent && !item.exact) {
    const [minLng, maxLat, maxLng, minLat] = item.extent;
    if (maxLng - minLng > 0.01 || maxLat - minLat > 0.01) {
      const bounds: [[number, number], [number, number]] = [
        [minLng, minLat],
        [maxLng, maxLat],
      ];
      const options = { padding: 60, maxZoom: 14 };
      const camera = map.cameraForBounds(bounds, options);
      const duration = camera?.center ? flightDuration(map, camera.center, camera.zoom) : undefined;
      map.fitBounds(bounds, { ...options, duration });
      return;
    }
  }
  const center: [number, number] = [item.lng, item.lat];
  const zoom = Math.max(map.getZoom(), 13);
  map.flyTo({ center, zoom, duration: flightDuration(map, center, zoom) });
}
